import templates from '../../api/templates'
import dashboard from '../../api/dashboard'

const state = {
  reviewList: [],
  messageStats: [],
  chartLoading: true,
  tableLoading: true,
  statsLoading: true
};

const actions = {
  // 获取模板审批进度信息
  async getReviewList ({ commit }, payload) {
    const response = await templates.getTemplates(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_REVIEWLIST', {
        templates: data.templates
      });
      commit('UPDATE_LOADING', {
        chartLoading: false,
        tableLoading: false
      });
    }
  },
  // 获取短信送达率统计信息
  async getMessageStats ({ commit }, payload) {
    const response = await dashboard.getMessageStats(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_MESSAGE_STATS', {
        messageStats: data.data
      });
      commit('UPDATE_STATS_LOADING', {
        statsLoading: false
      });
    }
  }
};

const mutations = {
  'UPDATE_REVIEWLIST': (state, payload) => {
    state.reviewList = payload.templates;
  },
  'UPDATE_LOADING': (state, payload) => {
    state.chartLoading = payload.chartLoading;
    state.tableLoading = payload.tableLoading;
  },
  'UPDATE_MESSAGE_STATS': (state, payload) => {
    state.messageStats = payload.messageStats;
  },
  'UPDATE_STATS_LOADING': (state, payload) => {
    state.statsLoading = payload.statsLoading;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js